var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Workbox } from "workbox-window";
import { getCookie, setCookie, deleteCookie } from "./utils";
export * from "./service-worker";
/**
 * Sets up a service worker for your application. Will not run on localhost.
 *
 * Features:
 * - Easy debug mode toggle via URL parameters
 * - Enable/disable service worker via URL
 * - Configurable service worker path
 * - Configurable scope
 * - Page update notifications
 *
 * @param {ServiceWorkerInit} options - All options are optional
 * @returns {void}
 *
 * @example
 * // Basic setup with defaults
 * registerServiceWorker();
 *
 * @example
 * // Custom setup with specific scope
 * registerServiceWorker({
 *   swPath: "/service-worker.js",
 *   scope: "/app/",  // Service worker will only control /app/ paths
 *   pageUpdatedCallback: async ({ cacheName, updatedURL }) => {
 *     console.log(`Content updated at: ${updatedURL}`);
 *   }
 * });
 */
export var registerServiceWorker = function (options) {
    if (options === void 0) { options = {}; }
    if ("serviceWorker" in navigator && !window.location.host.match(/localhost/)) {
        var url = new URL(window.location.href);
        var swOptions = url.searchParams.getAll("sw");
        var enabledOptions = Object.entries(options)
            .filter(function (_a) {
            var _b = __read(_a, 2), _ = _b[0], value = _b[1];
            return value;
        })
            .map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
        swOptions = swOptions.concat(enabledOptions);
        // lets add a way to pass a querystring to the url to force a service worker update
        swOptions.includes("debug-on") && setCookie("service-worker-debug", "true", 30);
        swOptions.includes("debug-off") && setCookie("service-worker-debug", "false", 30);
        if (swOptions.includes("disable")) {
            setCookie("service-worker-disable", "true", 30);
            return unregisterSW();
        }
        swOptions.includes("enable") && deleteCookie("service-worker-disable");
        if (getCookie("service-worker-disable") === "true")
            return;
        workboxRegister(options);
        if (options.pageUpdatedCallback) {
            navigator.serviceWorker.addEventListener("message", function (event) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, cacheName, updatedURL;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(event.data.meta === "workbox-broadcast-update")) return [3 /*break*/, 2];
                            _a = event.data.payload, cacheName = _a.cacheName, updatedURL = _a.updatedURL;
                            return [4 /*yield*/, ((_b = options.pageUpdatedCallback) === null || _b === void 0 ? void 0 : _b.call(options, { cacheName: cacheName, updatedURL: updatedURL }))];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        }
    }
};
/**
 * Removes all registered service workers and refreshes the page.
 * You can trigger this programmatically or by adding ?sw=disable to the URL.
 *
 * @returns {void}
 *
 * @example
 * // Remove service worker programmatically
 * unregisterSW();
 */
export var unregisterSW = function () {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var e_1, _a;
        try {
            for (var registrations_1 = __values(registrations), registrations_1_1 = registrations_1.next(); !registrations_1_1.done; registrations_1_1 = registrations_1.next()) {
                var registration = registrations_1_1.value;
                registration.unregister().then(function (unregistered) {
                    if (unregistered) {
                        console.log("Service worker unregistered successfully");
                        deleteCookie("service-worker-debug");
                        window.location.reload();
                    }
                    else
                        console.log("Service worker unregistration failed");
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (registrations_1_1 && !registrations_1_1.done && (_a = registrations_1.return)) _a.call(registrations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
};
/**
 * Internal helper to register the Workbox service worker.
 * You shouldn't need to call this directly - use registerServiceWorker() instead.
 *
 * @param {ServiceWorkerInit} options - Service worker configuration
 * @returns {void}
 * @internal
 */
export var workboxRegister = function (options) {
    var swPath = options.swPath || "/sw.js";
    var wb = new Workbox(swPath, {
        scope: options.scope || "/",
        debug: getCookie("service-worker-debug") === "true"
    });
    wb.register();
};
